// src/components/access/ExposureRouteGate.tsx
// Wraps a route element — renders NotFound when exposure flag is false.
import { useFeatureStore } from '@/stores/featureStore';
import type { ExposureKey } from '@/lib/features/featureFlags';
import NotFound from '@/pages/NotFound';

export function ExposureRouteGate({ feature, children }: {
  feature: ExposureKey;
  children: React.ReactNode;
}) {
  const { exposureFlags } = useFeatureStore();

  // Flags not loaded yet — render nothing (avoids flash of NotFound)
  if (!exposureFlags) return null;
  if (!exposureFlags[feature]) return <NotFound />;

  return <>{children}</>;
}
